module.exports = __webpack_public_path__ + "img/com_mr.dc7091d9.png";